/* tslint:disable */

declare var Object: any;
export interface TschatrealtimeInterface {
  "id"?: number;
}

export class Tschatrealtime implements TschatrealtimeInterface {
  "id": number;
  constructor(data?: TschatrealtimeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tschatrealtime`.
   */
  public static getModelName() {
    return "Tschatrealtime";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tschatrealtime for dynamic purposes.
  **/
  public static factory(data: TschatrealtimeInterface): Tschatrealtime{
    return new Tschatrealtime(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tschatrealtime',
      plural: 'Tschatrealtimes',
      path: 'Tschatrealtimes',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tschatrealtime.ts